import React from 'react';
import { TrafficIcon } from '../icons/TrafficIcon';
import { ViewsIcon } from '../icons/ViewsIcon';
import { AttentionIcon } from '../icons/AttentionIcon';
import { AnalyticType } from '../../model/AnalyticType';
import { DwellIcon } from '../icons/DwellIcon';
import { AgeIcon } from '../icons/AgeIcon';
import { GenderIcon } from '../icons/GenderIcon';
import { EarningsIcon } from '../icons/EarningsIcon';

const HistoricalIcon = ({ type }: Props) => {
  if(type === AnalyticType.views) {
    return <ViewsIcon size="sm" />
  }
  else if(type === AnalyticType.attention) {
    return <AttentionIcon size="sm" />
  }
  else if(type === AnalyticType.dwell) {
    return <DwellIcon size="sm" />
  }
  else if(type === AnalyticType.age) {
    return <AgeIcon size="sm" />
  }
  else if(type === AnalyticType.gender) {
    return <GenderIcon size="sm" />
  }
  else if(type === AnalyticType.sales) {
    return <EarningsIcon size="sm" />
  }
  return <TrafficIcon size="sm" />;
}

interface Props {
  type: AnalyticType
}

export { HistoricalIcon };